import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ApiClient } from '../../../api-client';
import { UnitResult } from '../../../error';
import { JobRate } from '../../Domain/Model/Job/VO/job-rate';
import { EstimateJobHourlyRateService } from '../../Domain/Port/EstimateJob/estimate-job-hourly-rate.service';
import { EstimateJobRequest } from '../../Domain/Port/EstimateJob/estimate-job-request.model';
import { JobHourlyRateResponse } from '../../Domain/Port/EstimateJob/job-hourly-rate-response';

@Injectable({
    providedIn: 'root'
})
export class BackendEstimateJobHourlyRateService extends EstimateJobHourlyRateService {
    private readonly endpoint = '/job/estimate';

    constructor(private readonly apiClient: ApiClient) {
        super();
    }

    override execute(model: EstimateJobRequest): Observable<UnitResult<JobRate>> {
        return this.apiClient.post<EstimateJobRequest, JobHourlyRateResponse>(this.endpoint, model, true).pipe(
            map(result => {
                if (result.isSuccess()) {
                    return UnitResult.success<JobRate>(
                        new JobRate(result.getResult().rate, result.getResult().isUrgent)
                    );
                } else {
                    return UnitResult.failure<JobRate>(result.getErrors());
                }
            })
        );
    }
}
